import { ErrorBoundary, RouteProgress, Toaster } from "@nymbl/nos2-rules";
import { QueryClientProvider } from "@tanstack/react-query";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { ThemeProvider } from "@/components/layout/ThemeProvider";
import { queryClient } from "@/lib/query";

export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const loading = useRouterState({ select: (s) => s.isLoading });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <RouteProgress loading={loading} />
        <ErrorBoundary resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
        <Toaster />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
